module.exports = __webpack_public_path__ + "static/media/16.664f79bd.jpg";